module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nba/weekly_wt-81719de1f9ab165e0d2b7e44bc9ab354.svg";